import Logo from "../../assets/365_Icon.svg";
import X from "../../assets/twitter.svg";
import Facebook from "../../assets/Facebook.svg";
import Instagram from "../../assets/instagram.svg";
import Linkedin from "../../assets/linkedin.svg";
import Location from "../../assets/img/Location.svg";
import Mail from "../../assets/img/email.svg";
import SubLogo from "../../assets/img/365_studyabroadwithease_04.png";

import React from 'react';
import IASBadge from "../Badge";

const Footer = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/365globalconsultng/", name: "instagram" },
    { icon: Linkedin, url: "https://www.linkedin.com/company/365-global-consulting-nigeria", name: "linkedin" },
    { icon: X, url: "https://x.com/365global_edu", name: "x" },
    { icon: Facebook, url: "https://www.facebook.com/p/365-Global-Consult-100078106966760/", name: "facebook" }
  ];

  const locations = [
    {
      title: "Lagos Office",
      address: "1st Floor, West End Plaza 25, Montgomery Road, Yaba, Lagos"
    },
    {
      title: "Abuja Office",
      address: "Suite 108, De Avalon Plaza, No, 483 Ajose Adeogun Crescent, Utako District, Abuja"
    },
    {
      title: "Port Harcourt Office",
      address: "The Autograph, 30 Sani Abacha Road GRA phase 3, Port Harcourt"
    },
    {
      title: "Kano Office",
      address: "35, Lamido Crescent Nassarawa GRA, Kano State"
    }
  ];

  const studyDestinations = [
    { name: "UK", path: "/destination/uk" },
    { name: "US", path: "/destination/us" },
    { name: "Canada", path: "/destination/canada" },
    { name: "Italy", path: "/destination/italy" }
  ];

  const companyLinks = [
    { name: "About Us", path: "/about" },
    { name: "Our Services", path: "/services" },
    { name: "Contact Us", path: "/contactus" }
  ];

  return (
    <footer className="bg-primary text-white relative mt-14">
      {/* Desktop and Tablet Layout */}
      <div className="container mx-auto hidden md:block px-4 lg:px-6">
        <div className="grid lg:grid-cols-12 gap-8 py-24">
          {/* Company Info Section */}
          <div className="lg:col-span-5">
            <div className="space-y-4">
              <div className="">
                <img src={Logo} alt="365 global consulting Logo" className="w-48 h-auto" />
                <img src={SubLogo} alt="365 global consulting Logo" className="w-44 h-auto" />
              </div>
              <p className="text-sm text-white/80 max-w-sm">
                As a trusted, independent education consulting firm, we deliver
                impartial, expert guidance and personalized educational services.
                Our commitment to transparency, integrity, and student-centricity
                enables us to provide well-rounded career counselling, fostering a
                brighter future for our clients.
              </p>
              <div className="flex gap-4 pt-2">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noreferrer"
                    className="hover:opacity-80 transition-opacity"
                  >
                    <img src={social.icon} alt={social.name} className="w-6 h-6" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="lg:col-span-4">
            <p className="font-bold text-sm mb-6">CONTACT</p>
            <div className="space-y-6">
              {locations.map((location, index) => (
                <div key={index} className="flex gap-3">
                  <img src={Location} alt="location" className="w-6 h-6 flex-shrink-0 mt-1" />
                  <p className="text-sm text-white/70">{location.address}</p>
                </div>
              ))}
              <div className="flex gap-3">
                <img src={Mail} alt="email" className="w-6 h-6 flex-shrink-0" />
                <a
                  href="mailto:info@365globalconsulting.com"
                  className="text-sm hover:text-secondary transition-colors"
                >
                  info@365globalconsulting.com
                </a>
              </div>
            </div>
          </div>

          {/* Links Section */}
          <div className="lg:col-span-3">
            <div className="grid grid-cols-2 gap-8">
              <div>
                <p className="font-bold text-sm mb-6">COMPANY</p>
                <div className="flex flex-col space-y-4">
                  {companyLinks.map((link) => (
                    <a
                      key={link.name}
                      href={link.path}
                      className="text-sm text-white/60 hover:text-white transition-colors"
                    >
                      {link.name}
                    </a>
                  ))}
                </div>
              </div>
              <div>
                <p className="font-bold text-sm mb-6">STUDY ABROAD</p>
                <div className="flex flex-col space-y-4">
                  {studyDestinations.map((destination) => (
                    <a
                      key={destination.name}
                      href={destination.path}
                      className="text-sm text-white/60 hover:text-white transition-colors"
                    >
                      Study in {destination.name}
                    </a>
                  ))}
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden px-4 py-12">
        <div className="space-y-8">
          {/* Logo and Description */}
          <div className="space-y-4">
            <img src={Logo} alt="365 global consulting Logo" className="w-48 h-auto" />
            <p className="text-sm text-white/80">
              As a trusted, independent education consulting firm, we deliver
              impartial, expert guidance and personalized educational services.
              Our commitment to transparency, integrity, and student-centricity
              enables us to provide well-rounded career counselling, fostering a
              brighter future for our clients.
            </p>
          </div>

          {/* Mobile Navigation Links */}
          <div className="grid grid-cols-2 gap-8">
            <div>
              <h3 className="font-bold text-sm mb-4">STUDY ABROAD</h3>
              <div className="flex flex-col space-y-3">
                {studyDestinations.map((destination) => (
                  <a
                    key={destination.name}
                    href={destination.path}
                    className="text-sm text-white/70 hover:text-white"
                  >
                    Study in {destination.name}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <h3 className="font-bold text-sm mb-4">COMPANY</h3>
              <div className="flex flex-col space-y-3">
                {companyLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.path}
                    className="text-sm text-white/70 hover:text-white"
                  >
                    {link.name}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-6">
            <h3 className="font-bold text-sm">CONTACT</h3>
            {locations.map((location, index) => (
              <div key={index} className="flex gap-3">
                <img src={Location} alt="location" className="w-6 h-6 flex-shrink-0 mt-1" />
                <p className="text-sm text-white/70">{location.address}</p>
              </div>
            ))}
            <div className="flex gap-3">
              <img src={Mail} alt="email" className="w-6 h-6 flex-shrink-0" />
              <a
                href="mailto:info@365globalconsulting.com"
                className="text-sm hover:text-secondary"
              >
                info@365globalconsulting.com
              </a>
            </div>
            {/* <img
                src={Cert}
                alt="365 global consulting Cert"
                className="rounded-xl w-72 h-auto mt-8"
              /> */}
              
          </div>

          {/* Social Links */}
          <div className="flex gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img src={social.icon} alt={social.name} className="w-6 h-6" />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="mb-10 md:ms-28 ms-6">
              <IASBadge />
              </div>
      <div className="border-t border-white/20">
        <p className="py-6 text-center text-sm">
          Copyright © {new Date().getFullYear()}. 365 Global Consulting
        </p>
      </div>
    </footer>
  );
};

export default Footer;